import { Group, SimpleGrid, Stack, Text, UnstyledButton, useMantineTheme } from '@mantine/core'
import { SectionPlaceholder } from '../SectionPlaceholder'
import { BrandBlogger, BrandGithub, BrandLinkedin, BrandVscode } from 'tabler-icons-react'
import { useMediaQuery } from '@mantine/hooks'
import { useMemo } from 'react'

export const Footer: React.FC = () => {
  const theme = useMantineTheme()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.md})`)

  const year = new Date().getFullYear()

  const textColor = theme.colorScheme === 'dark' ? theme.colors.gray[2] : theme.colors.gray[7]

  const iconSize = useMemo(() => (isMobile ? 40 : 24), [isMobile])

  const CompanyDetails = () => (
    <Stack spacing="xs" align={isMobile ? 'center' : 'flex-end'}>
      <Text color={theme.colors.blue[4]} sx={{ cursor: 'pointer', fontWeight: 600 }}>
        <a
          href="https://thewebmate.in"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: 'inherit',
            textDecoration: 'none',
          }}
        >
          Webmate
        </a>
      </Text>
      <Text color={textColor}>Ahmedabad, Gujarat, India</Text>
    </Stack>
  )

  const CopyRightDetails = () => (
    <Stack spacing="xs" align={'center'}>
      <Text color={textColor}>© {year} Tirth Patel</Text>
      <Text color={textColor}>Made with ❤️ from India</Text>
    </Stack>
  )

  const SocialMediaButton: React.FC<{ icon: React.ReactNode; link: string; title: string }> = ({
    icon,
    link,
    title,
  }) => (
    <UnstyledButton
      sx={{
        cursor: 'pointer',
        borderRadius: '50%',
        textAlign: 'center',
        height: 40,
        width: 40,
        marginInline: 3,
        color: theme.colorScheme === 'dark' ? theme.colors.gray[4] : theme.colors.gray[7],
        ':hover': {
          background: 'rgba(200, 225, 250, 0.6)',
        },
      }}
      title={title}
    >
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: 'inherit',
          textDecoration: 'none',
        }}
      >
        {icon}
      </a>
    </UnstyledButton>
  )

  const SocialMediaDetails = () => (
    <Group spacing={isMobile ? 32 : 8} position={isMobile ? 'center' : 'left'}>
      <SocialMediaButton
        icon={<BrandLinkedin size={iconSize} />}
        link="https://www.linkedin.com/in/tirth-patel-2001/"
        title="LinkedIn"
      />
      <SocialMediaButton icon={<BrandGithub size={iconSize} />} link="https://github.com/tirth-2001" title="GitHub" />
      <SocialMediaButton
        icon={<BrandVscode size={iconSize} />}
        link="https://marketplace.visualstudio.com/publishers/TirthPatel"
        title="VSCode Marketplace"
      />
      <SocialMediaButton
        icon={<BrandBlogger size={iconSize} />}
        link="https://tirthpatel.hashnode.dev"
        title="Hashnode"
      />
    </Group>
  )

  return (
    <SectionPlaceholder showBorder={false}>
      <SimpleGrid cols={3} spacing={50} breakpoints={[{ maxWidth: 'md', cols: 1 }]} sx={{ alignItems: 'flex-start' }}>
        <SocialMediaDetails />
        <CopyRightDetails />
        <CompanyDetails />
      </SimpleGrid>
    </SectionPlaceholder>
  )
}
